<template>
    <div class="section" id="page" >
        <div id="splits">
            <div class="cover" id="one">

    
        <svg viewBox="0 0 500 500">
    <path id="curve" d="M73.2,148.6c4-6.1,65.5-96.8,178.6-95.6c111.3,1.2,170.8,90.3,175.1,97" />
    <text width="500">
      <textPath xlink:href="#curve">
        Explore my latest projects Enjoy
      </textPath>
    </text>
  </svg>

  <div id="title2">
    Projects
  </div>
  <button id="expb">
    Explore
  </button>



            </div>
 <div class="cover" id="bigger">
<h1 class="fire">ABOUTABOUTABOUTABOUT</h1>
<h1 class="fire">ABOUTABOUTABOUTABOUT</h1>
<h1 class="fire">ABOUTABOUTABOUTABOUT</h1>
<h1 class="fire">ABOUTABOUTABOUTABOUT</h1>
<h1 class="fire">ABOUTABOUTABOUTABOUT</h1>
<h1 class="fire">ABOUTABOUTABOUTABOUT</h1>
<h1 class="fire">ABOUTABOUTABOUTABOUT</h1>
<h1 class="fire">ABOUTABOUTABOUTABOUT</h1>
<h1 class="fire">ABOUTABOUTABOUTABOUT</h1>
<h1 class="fire">ABOUTABOUTABOUTABOUT</h1>
<h1 class="fire">ABOUTABOUTABOUTABOUT</h1>
<h1 class="fire">ABOUTABOUTABOUTABOUT</h1>
<h1 class="fire">ABOUTABOUTABOUTABOUT</h1>




 </div>
 <div class="cover" id="three">
  <h1 id="threes">ContactMe</h1>
 </div>
        </div>

        

    </div>
</template>

<script>
    
    export default {
        name : 'Explore',
     
    }
</script>
